module.exports = __webpack_public_path__ + "img/pro-m-slider1.5325cc24.png";